var _polygon, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcessoVelocidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0000",
    points: "41.4,2.4 18.6,2.4 2.4,18.6 2.4,41.4 18.6,57.6 41.4,57.6 57.6,41.4 57.6,18.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.9,25c0,0-19.4,14.9-19.7,15.2c-1.7,2-1.5,5,0.5,6.8c2,1.7,5,1.5,6.8-0.5C33.7,46.2,45.9,25,45.9,25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.9,28.1h4.8c-0.5-4.8-2.4-9.2-5.3-12.7L45,18.8C47.1,21.5,48.5,24.6,48.9,28.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.7,15.5l3.4-3.4c-3.5-2.9-7.9-4.8-12.7-5.3v4.8C35.8,12,39,13.4,41.7,15.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.6,11.6V6.8c-4.8,0.5-9.2,2.4-12.7,5.3l3.4,3.4C20.9,13.4,24.1,12,27.6,11.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11.5,15.4C8.6,19,6.7,23.4,6.2,28.1h4.8c0.4-3.5,1.8-6.7,3.9-9.3C14.9,18.8,11.5,15.4,11.5,15.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcessoVelocidade);
export default __webpack_public_path__ + "static/media/excesso-velocidade.8c6e5423169b2fa0e72a3ee42ab99d76.svg";
export { ForwardRef as ReactComponent };